'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_Fetcher$$anon$6() {
  this.aSS = null;
  this.aST = false;
}
export { $c_Lpresto_Fetcher$$anon$6 as $c_Lpresto_Fetcher$$anon$6 };
$p = $c_Lpresto_Fetcher$$anon$6.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Fetcher$$anon$6;
/** @constructor */
function $h_Lpresto_Fetcher$$anon$6() {
}
export { $h_Lpresto_Fetcher$$anon$6 as $h_Lpresto_Fetcher$$anon$6 };
$h_Lpresto_Fetcher$$anon$6.prototype = $p;
$p.P = (function() {
  if ((!this.aST)) {
    this.aSS = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T5($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some(500), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$()));
    this.aST = true;
  }
  return this.aSS;
});
var $d_Lpresto_Fetcher$$anon$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Fetcher$$anon$6, "presto.Fetcher$$anon$6", ({
  Iu: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_Fetcher$$anon$6 as $d_Lpresto_Fetcher$$anon$6 };
//# sourceMappingURL=presto.-Fetcher$$anon$6.js.map
